// Autogenerated from `packages/@members/copy/models.generated/__model__.ts.hbs`

export const Challenges = {
  Active: 'active',
  ActiveDays: 'activeDays',
  ActiveDaysPreviewDescription: 'activeDaysPreviewDescription',
  ActiveMessage: 'activeMessage',
  ActiveTitle: 'activeTitle',
  BadgeProgressScreenReader: 'badgeProgressScreenReader',
  BikeBootcamp: 'bikeBootcamp',
  ByYou: 'byYou',
  Cardio: 'cardio',
  ChallengeCalculatorTitle: 'challengeCalculatorTitle',
  ChallengeCalendarTitle: 'challengeCalendarTitle',
  ChallengeCreateStepsChallengeType: 'challengeCreateStepsChallengeType',
  ChallengeDetails: 'challengeDetails',
  ChallengeDisciplineSelectionTitle: 'challengeDisciplineSelectionTitle',
  ChallengeDisciplinesSubtitle: 'challengeDisciplinesSubtitle',
  ChallengeDurationSelectionTitle: 'challengeDurationSelectionTitle',
  ChallengeFinishersPermissionCTA: 'challengeFinishersPermissionCTA',
  ChallengeFinishersPermissionDecline: 'challengeFinishersPermissionDecline',
  ChallengeFinishersPermissionDescription: 'challengeFinishersPermissionDescription',
  ChallengeFinishersPermissionModalLabel: 'challengeFinishersPermissionModalLabel',
  ChallengeFinishersPermissionTitle: 'challengeFinishersPermissionTitle',
  ChallengePreviewTitle: 'challengePreviewTitle',
  ChallengeTiers: 'challengeTiers',
  ChallengeTypeSelectionTitle: 'challengeTypeSelectionTitle',
  ClassType: 'classType',
  CommunityLabelText: 'communityLabelText',
  CommunityTotal: 'communityTotal',
  Completed: 'completed',
  CompletedHeader: 'completedHeader',
  CompletedMessage: 'completedMessage',
  CompletedTitle: 'completedTitle',
  Coworkers: 'coworkers',
  CreatePersonalChallenge: 'createPersonalChallenge',
  CurrentStep: 'currentStep',
  Cycling: 'cycling',
  Days: 'days',
  DaysLeft: 'daysLeft',
  DigitalMemberModalDesc: 'digitalMemberModalDesc',
  DigitalMemberModalTitle: 'digitalMemberModalTitle',
  DigitalTrialModalDesc: 'digitalTrialModalDesc',
  DigitalTrialModalTitle: 'digitalTrialModalTitle',
  Distance: 'distance',
  DistancePreviewDescription: 'distancePreviewDescription',
  EarnedBadgeAlt: 'earnedBadgeAlt',
  EarnedTier: 'earnedTier',
  EndedDate: 'endedDate',
  FriendsParticipating: 'friendsParticipating',
  HardwareModalDesc: 'hardwareModalDesc',
  HardwareModalTitle: 'hardwareModalTitle',
  Hours: 'hours',
  IndividualLabelText: 'individualLabelText',
  InvalidActiveDays: 'invalidActiveDays',
  Join: 'join',
  JoinConfirmation: 'joinConfirmation',
  Joined: 'joined',
  Leave: 'leave',
  LeaveChallenge: 'leaveChallenge',
  LeaveConfirmation: 'leaveConfirmation',
  LeaveDeletionWarning: 'leaveDeletionWarning',
  Link: 'link',
  Meditation: 'meditation',
  Miles: 'miles',
  More: 'more',
  NavLabel: 'navLabel',
  NextBadgeAlt: 'nextBadgeAlt',
  NoneCompleted: 'noneCompleted',
  NoUpcoming: 'noUpcoming',
  NumberOfWeeks: 'numberOfWeeks',
  OnboardingModalCTA: 'onboardingModalCTA',
  OnboardingTooltip: 'onboardingTooltip',
  Participants: 'participants',
  PersonalChallenge: 'personalChallenge',
  PersonalChallengeTitle: 'personalChallengeTitle',
  PersonalLabelText: 'personalLabelText',
  Publish: 'publish',
  PublishError: 'publishError',
  Running: 'running',
  SelectAllClasses: 'selectAllClasses',
  StartsIn: 'startsIn',
  StartsInDays: 'startsInDays',
  Strength: 'strength',
  Stretching: 'stretching',
  SymbolAltText: 'symbolAltText',
  Teammates: 'teammates',
  TierEarned: 'tierEarned',
  TierImageAlt: 'tierImageAlt',
  Title: 'title',
  ToNextTier: 'toNextTier',
  TotalActiveDaysChallenge: 'totalActiveDaysChallenge',
  TotalDistanceChallenge: 'totalDistanceChallenge',
  TotalHours: 'totalHours',
  TotalWorkouts: 'totalWorkouts',
  TotalWorkoutsChallenge: 'totalWorkoutsChallenge',
  TotalWorkoutsPreviewDescription: 'totalWorkoutsPreviewDescription',
  TotalWorkoutTimeChallenge: 'totalWorkoutTimeChallenge',
  TreadBootcamp: 'treadBootcamp',
  Unearned: 'unearned',
  UnitPerDay: 'unitPerDay',
  UnitPerWeek: 'unitPerWeek',
  UnitsCompleted: 'unitsCompleted',
  UnitToGoal: 'unitToGoal',
  UntilStart: 'untilStart',
  Upcoming: 'upcoming',
  UpcomingMessage: 'upcomingMessage',
  UpcomingTitle: 'upcomingTitle',
  ViewChallenges: 'viewChallenges',
  Walking: 'walking',
  Workouts: 'workouts',
  WorkoutTime: 'workoutTime',
  WorkoutTimePreviewDescription: 'workoutTimePreviewDescription',
  Yoga: 'yoga',
  JoinChallenge: 'joinChallenge',
  EmptyActiveChallengeDescription: 'emptyActiveChallengeDescription',
} as const;
